module.exports = __webpack_public_path__ + "media/images/bsmart/icons/da_assegnare_filtri_attivo-0fd4425bdb4ae4da76f210a036d1d859.svg";